import { css } from '@emotion/react';

import {
	contrastingTextColor,
	nameToHash,
	su,
} from '@adflow/frontend/ui-theme';
import { getInitials } from '@adflow/shared/util-formatting';

const sizes = {
	regular: {
		container: css({ width: '2rem', height: '2rem' }),
		text: css({ fontSize: '0.9rem' }),
	},
	small: {
		container: css({ width: '1.5rem', height: '1.5rem' }),
		text: css(su.textXs),
	},
} as const;

export interface AvatarProps {
	name: string;
	initials?: string;
	size?: keyof typeof sizes;
}

export function Avatar({
	name,
	initials = getInitials(name),
	size = 'regular',
}: AvatarProps) {
	const backgroundColor = nameToHash(name);
	const textColor = contrastingTextColor(backgroundColor);

	return (
		<div
			css={[
				{ backgroundColor },
				su.roundedFull,
				{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexShrink: 0,
				},
				sizes[size].container,
			]}
		>
			<p
				css={[{ color: textColor }, sizes[size].text, { fontStyle: 'normal' }]}
			>
				{initials}
			</p>
		</div>
	);
}
